import React from 'react';
import { Sprout, TrendingUp, Truck, Award } from 'lucide-react';
import { Card, CardContent } from './ui/card';

export const About = () => {
  const features = [
    {
      icon: <Sprout className="w-10 h-10 text-[#019645]" />,
      title: "Producción Consistente",
      description: "Cultivamos con técnicas modernas para garantizar disponibilidad constante de productos frescos."
    },
    {
      icon: <TrendingUp className="w-10 h-10 text-[#019645]" />,
      title: "Abastecimiento Mayorista",
      description: "Capacidad para abastecer grandes volúmenes a supermercados, distribuidores y sector hotelero."
    },
    {
      icon: <Truck className="w-10 h-10 text-[#019645]" />,
      title: "Entregas Puntuales",
      description: "Logística confiable con entregas a nivel nacional en los tiempos acordados."
    },
    {
      icon: <Award className="w-10 h-10 text-[#019645]" />,
      title: "Calidad Garantizada",
      description: "Productos con trazabilidad por lote y buenas prácticas agrícolas en cada cosecha."
    }
  ];

  return (
    <section id="nosotros" className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            ¿Quiénes Somos?
          </h2>
          <div className="w-24 h-1 bg-[#019645] mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            GONSO es una empresa agrícola hondureña especializada en la producción y comercialización de hortalizas frescas al por mayor. 
            Ubicados en El Pescadero, Danlí, trabajamos con enfoque en la calidad, consistencia y relaciones comerciales a largo plazo.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {features.map((feature, index) => (
            <Card
              key={index}
              className="border-none shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 bg-white"
            >
              <CardContent className="p-8 text-center">
                <div className="mb-4 flex justify-center">{feature.icon}</div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
                <p className="text-gray-600 leading-relaxed">{feature.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 border-t-4 border-[#019645]">
          <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">Nuestra Visión</h3>
          <p className="text-lg text-gray-700 text-center max-w-4xl mx-auto leading-relaxed">
            Con más de 10 años de experiencia, nos proyectamos como líderes en el abastecimiento de hortalizas frescas en Honduras, 
            preparándonos estratégicamente para expandir nuestras operaciones hacia la exportación internacional, 
            manteniendo siempre los más altos estándares de calidad e inocuidad alimentaria.
          </p>
        </div>
      </div>
    </section>
  );
};
